import Swiper from "swiper";

const kitProfitSections = document.querySelectorAll(".js-kit-profit-swiper-init");

if (kitProfitSections) {
    kitProfitSections.forEach((section) => initKitProfitSlider(section));
}

function initKitProfitSlider(section) {
    const swiperContainer = section.querySelector(".swiper-container");
    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
            nextEl: section.querySelector(".swiper-button-next"),
            prevEl: section.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: section.querySelector(".swiper-pagination"),
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
        },
        breakpoints: {
            375: {
                slidesPerView: 1.7,
            },
            470: {
                slidesPerView: 2.1,
            },
            570: {
                slidesPerView: 2.5,
            },
            670: {
                slidesPerView: 2.9,
            },
            768: {
                slidesPerView: 4.2,
            },
        },
    });
}
